<script>
  import { Button, Heading } from 'flowbite-svelte';
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';
  import { getCookie, setCookie } from './utils';
  import { _ } from 'svelte-i18n';

  export let isShowingHelpModal;

  const HIDE_COOKIE = 'btn_hide_help';

  let isShowing = false;

  onMount(async () => {
    isShowing = !getCookie(HIDE_COOKIE);
  });

  function onDismiss(event) {
    event.preventDefault();
    isShowing = false;
    setCookie(HIDE_COOKIE, true);
  }
</script>

{#if isShowing}
  <div
    transition:slide
    class="relative mt-14 flex flex-col items-center justify-start gap-x-6 gap-y-4 rounded-lg bg-yellow-50 p-6 align-middle lg:flex-row"
  >
    <p class="absolute right-6 top-6 text-3xl lg:static">💡</p>
    <div class="flex flex-col gap-y-2">
      <Heading tag="h2" class="text-base font-bold">
        {$_('StickyHelp.header', { default: 'Welcome!' })}
      </Heading>
      <p
        class="text-sm font-medium leading-5 text-gray-600"
        style="left: 80px; top: 56px;"
      >
        {$_('StickyHelp.body', {
          default:
            'Creating shortlinks can help grow mobile conversions and affiliate commissions. Check out our instructions for help getting started.',
        })}
      </p>
    </div>
    <div class="flex w-full flex-col gap-y-2 lg:w-64">
      <Button
        on:click={() => {
          isShowingHelpModal.set(true);
        }}
        size="md"
        color="dark"
        pill
        class="!text-base !font-bold"
      >
        {$_('StickyHelp.cta.instructions', {
          default: 'See Instructions',
        })}
      </Button>
      <Button
        on:click={onDismiss}
        size="md"
        color="alternative"
        pill
        class="border-gray-500 bg-yellow-50 !py-2 !text-base !font-bold hover:bg-yellow-100/50 hover:text-gray-900 focus:text-gray-900"
      >
        {$_('StickyHelp.cta.dismiss', {
          default: 'Dismiss',
        })}
      </Button>
    </div>
  </div>
{/if}
